import request from '@/utils/request'


// 查询名医荣誉信息列表
export function listDoctorHonor(query) {
  return request({
    url: '/doctor/doctorHonor/list',
    method: 'get',
    params: query
  })
}

// 查询名医荣誉信息分页
export function pageDoctorHonor(query) {
  return request({
    url: '/doctor/doctorHonor/page',
    method: 'get',
    params: query
  })
}

// 查询名医荣誉信息详细
export function getDoctorHonor(data) {
  return request({
    url: '/doctor/doctorHonor/detail',
    method: 'get',
    params: data
  })
}

// 新增名医荣誉信息
export function addDoctorHonor(data) {
  return request({
    url: '/doctor/doctorHonor/add',
    method: 'post',
    data: data
  })
}

// 修改名医荣誉信息
export function updateDoctorHonor(data) {
  return request({
    url: '/doctor/doctorHonor/edit',
    method: 'post',
    data: data
  })
}

// 删除名医荣誉信息
export function delDoctorHonor(data) {
  return request({
    url: '/doctor/doctorHonor/delete',
    method: 'post',
    data: data
  })
}
